import { create } from "zustand";
import type { RegionColombia } from "../../../data/colombia";

/**
 * Estado de capas y filtros del modo "Red nacional CALE".
 * La selección reutiliza useHotspotStore (hotspotSlice) con ids
 * prefijados: `m:<divipola>`, `n:<N##>`, `s:<sedeId>`.
 */

export type CapaNacional = "municipios" | "nodos" | "sede" | "departamentos";
export type NivelAcceso = "todos" | "con-dato" | "sin-dato";

interface NationalState {
  capas: Record<CapaNacional, boolean>;
  filtroDepartamento: string | null;
  filtroRegion: RegionColombia | null;
  filtroAcceso: NivelAcceso;
  hoveredId: string | null;

  toggleCapa: (capa: CapaNacional) => void;
  setFiltroDepartamento: (codigo: string | null) => void;
  setFiltroRegion: (region: RegionColombia | null) => void;
  setFiltroAcceso: (nivel: NivelAcceso) => void;
  setHoveredId: (id: string | null) => void;
}

export const useNationalStore = create<NationalState>()((set) => ({
  capas: { municipios: true, nodos: true, sede: true, departamentos: false },
  filtroDepartamento: null,
  filtroRegion: null,
  filtroAcceso: "todos",
  hoveredId: null,

  toggleCapa: (capa) =>
    set((s) => ({ capas: { ...s.capas, [capa]: !s.capas[capa] } })),
  setFiltroDepartamento: (filtroDepartamento) => set({ filtroDepartamento }),
  setFiltroRegion: (filtroRegion) => set({ filtroRegion }),
  setFiltroAcceso: (filtroAcceso) => set({ filtroAcceso }),
  setHoveredId: (hoveredId) => set({ hoveredId }),
}));

export function idMunicipio(codigoDivipola: string): string {
  return `m:${codigoDivipola}`;
}
export function idNodo(id: string): string {
  return `n:${id}`;
}
export function idSede(id: string): string {
  return `s:${id}`;
}
